// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['virt_jquery_all', 'lodash4', 'react', 'react-router-dom',
    '/util/url.js', '/util/ajax.js',
    '/util/escape.js', '/www/util/pub/pure_component.js',
    '/util/setdb.js', '/util/match.js', '/util/date.js', '/util/storage.js',
    '/www/lum/pub/util.js', '/www/login/pub/campaign_bonus.js',
    '/www/lum/pub/util/hotjar.js', '/www/util/pub/react_hooks.js',
    'classnames', 'login_config', '/www/lum/pub/uikit.js'],
    ($, _, React, {withRouter}, url, ajax, zescape,
    Pure_component, setdb, match, date, storage,
    www_util, campaign_bonus, hotjar_util, react_hooks,
    classnames, {url_prefix}, {Tooltip})=>
{
const {use_effect, use_classic_state, use_state} = react_hooks;
const E = {};

// XXX saarya: depricated - remove If
const If = ({children, when})=>{
    if (!when)
        return null;
    return children instanceof Function ? children() : children;
};
E.If = If;

const Responsive = ({children, when, mobile, no_mobile})=>{
    const is_mobile = $(window).width()<=480;
    if (when=='mobile'&&is_mobile||when=='!mobile'&&!is_mobile)
        return children;
    return is_mobile ? mobile||null : no_mobile||null;
};
E.Responsive = Responsive;

class Popover extends Pure_component {
    constructor(props){
        super(props);
        this.state = {
            margin: props.margin==undefined ? 5 : props.margin,
            autoclose: props.autoclose==undefined ? 1 : props.autoclose,
            show_arrows: props.show_arrows,
            shadow: props.shadow==undefined ? 1 : props.shadow,
        };
        this.autoclose = 1;
    }
    autoclose(value){ this.autoclose = value; }
    show(){ this.setState({visible: 1}); }
    toggle(){ this.state.visible ? this.hide() : this.show(); }
    hide(){
        this.setState({visible: 0});
        if (this.props.on_hide)
            this.props.on_hide();
    }
    get_left(w){
        let p = this.props, m = this.state.margin, t = p.target()||{};
        if (p.position=='left')
            return t.offsetLeft-w.offsetWidth-this.state-m;
        if (p.position=='right')
            return t.offsetLeft+t.offsetWidth+m;
        if (p.align=='right')
            return t.offsetLeft+t.offsetWidth-(w.offsetWidth||0);
        if (p.align=='center')
            return t.offsetLeft+t.offsetWidth/2-(w.offsetWidth||0)/2;
        return t.offsetLeft;
    }
    get_top(w){
        let p = this.props, m = this.state.margin, t = p.target()||{};
        if (p.position=='top')
            return t.offsetTop-w.offsetHeight-m;
        if (p.position=='bottom')
            return t.offsetTop+t.offsetHeight+m;
        if (p.align=='top')
            return t.offsetTop;
        if (p.align=='middle')
            return t.offsetTop+t.offsetHeight/2-(w.offsetHeight||0)/2;
        return t.offsetTop+(t.offsetHeight||0)+m;
    }
    max_z_index(){
        return Array.from(document.querySelectorAll('body *'))
            .map(a=>parseFloat(window.getComputedStyle(a).zIndex))
            .filter(a=>!isNaN(a)).sort().pop();
    }
    content(){
        return (
            <div className="ru_panel rutils_boxshadow">
              {this.props.children}
            </div>
        );
    }
    render(){
        let z = this.max_z_index(), p = this.props;
        let wrapper_bind = r=>{
            if (!r || !p.target)
                return;
            this.wrapper = r;
            r.style.top = this.get_top(r)+'px';
            r.style.left = this.get_left(r)+'px';
        };
        return (
            <If when={this.state.visible}>
              <div ref={r=>wrapper_bind(r)}
                className={classnames('rutils_popover', p.classes)}
                style={{zIndex: z+2}}>
                <If when={this.state.show_arrows
                  && (p.position=='bottom' || !p.position)}>
                  <div>
                    <div className="arrow-up"></div>
                  </div>
                </If>
                {this.content()}
                <If when={this.state.show_arrows && p.position=='top'}>
                  <div>
                    <div className="arrow-down"></div>
                  </div>
                </If>
              </div>
              <If when={this.state.autoclose}>
                <div className="rutils_transparent_overflow"
                  onClick={()=>this.hide()}>
                  &nbsp;
                </div>
              </If>
            </If>
        );
    }
}
E.Popover = Popover;

let sitemap;
class Nav_hook extends Pure_component {
    constructor(props){
        super(props);
        this.reset = this.reset.bind(this);
    }
    check_campaign(){
        let campaign;
        if (!this.props.refresh_customer || !this.qs || !this.user
            || this.user.is_guest || !(campaign = campaign_bonus
            .campaign_bonus(this.qs.campaign)))
        {
            return;
        }
        let _this = this;
        return this.etask(function*(){
            let l = yield ajax({method: 'POST', url: '/users/landing_promo',
                qs: {campaign}});
            if (l)
            {
                _this.props.refresh_customer();
                _this.props.history.push(l);
            }
        });
    }
    componentDidMount(){
        const p = this.props;
        const l = this.props.location;
        if (p.hash_scroll&&l.hash)
            this.hash_scroll(l.hash);
        this.setdb_on('login.user', user=>{
            const url_o = url.parse(this.props.href);
            this.qs = url.qs_parse(url_o.query||'');
            this.user = user;
            this.check_campaign();
        });
        this.signup_page();
        this.location_changed(l);
    }
    page_view(){
        let l = this.props.location;
        // HS SPA pageview from GTM
        let _hsq = window._hsq = window._hsq || [];
        _hsq.push(['setPath', l.pathname+l.search]);
        _hsq.push(['trackPageView']);
    }
    componentDidUpdate(prevProps){
        this.location_changed(this.props.location);
        if (this.props.location == prevProps.location)
            return;
        const p = this.props;
        const l = this.props.location;
        const url_o = url.parse(l.href);
        this.qs = url.qs_parse(url_o.query||'');
        this.check_campaign();
        if (p.update_meta&&p.sitemap)
        {
            if (!sitemap)
            {
                this.etask([()=>ajax.json({url: p.sitemap}), sm=>{
                    sitemap = sm;
                    this.set_meta(url_o.pathname, this.qs);
                }]);
            }
            else
                this.set_meta(url_o.pathname, this.qs);
        }
        const same_pathname = this.props.location.pathname ==
            prevProps.location.pathname;
        if (p.scroll_to_top&&!l.hash&&!same_pathname)
            window.scrollTo(0, 0);
        if (p.hash_scroll&&l.hash)
            this.hash_scroll(l.hash);
        if (p.ga&&window.ga)
        {
            window.ga('set', 'page', l.pathname);
            window.ga('send', 'pageview');
        }
        if (p.on_nav)
            p.on_nav(url_o);
        if (p.redirect&&p.redirect[l.pathname])
            this.redirect();
        this.signup_page();
    }
    static active_location;
    build_url(location){
        location = location||{};
        return location.pathname+location.search+location.hash;
    }
    location_changed(location){
        Nav_hook.active_location = Nav_hook.active_location||'';
        let loc = this.build_url(location);
        if (loc == Nav_hook.active_location)
            return;
        Nav_hook.active_location = loc;
        this.page_view();
    }
    signup_page(){
        let {pathname, search, hash} = this.props.location;
        if (storage.get('signup_page')===null || pathname!='/cp'
            && pathname+search!='/?login=1' && !pathname.startsWith('/cp/'))
        {
            storage.set('signup_page', pathname+search+hash);
        }
        if (storage.get('signup_referrer')===null)
            storage.set('signup_referrer', document.referrer);
        if (storage.get('first_page_visited')===null)
            storage.set('first_page_visited', pathname+search+hash);
    }
    redirect(){
        let l = this.props.location;
        let _url = this.props.redirect[l.pathname]+l.search;
        this.props.history.replace(_url);
    }
    add_domain(path){
        return this.props.domain&&`https://${this.props.domain}${path}`||path;
    }
    set_meta(pathname, query){
        if (!sitemap)
            return;
        let m;
        for (let key in sitemap)
        {
            if (!match.match(key, pathname.toLowerCase(), {glob: 1}))
                continue;
            m = sitemap[key];
            break;
        }
        if (!m)
            return;
        m.og_url = this.add_domain(m.og_url||pathname);
        m.og_image = m.og_image&&this.add_domain(m.og_image);
        $('title').text(m.title);
        $('meta[name="description"]').attr('content', m.description);
        $('meta[property="og:url"]').attr('content', m.og_url);
        if (this.props.make_canonical)
        {
            let canonical = this.props.make_canonical(this.props.domain,
                pathname, query);
            $('link[rel="canonical"]').attr('href', canonical);
        }
        else
            $('link[rel="canonical"]').attr('href', m.og_url);
        $('meta[property="og:title"]').attr('content', m.og_title);
        $('meta[property="og:description"]').attr('content', m.og_description);
        $('meta[property="og:image"]').attr('content', m.og_image);
        $('meta[content=noindex]').remove();
        m.ga_num!==undefined&&window.set_ga_num&&window.set_ga_num(m.ga_num);
    }
    hash_scroll(hash){
        const id = hash?.replace('#', '');
        let el = document.getElementById(id);
        if (el)
            return el.scrollIntoView();
        const observer = new MutationObserver((m, o)=>{
            if (!(el = document.getElementById(id)))
                return;
            o.disconnect();
            el.scrollIntoView();
        });
        observer.observe(document.body, {
            attributes: false,
            characterData: false,
            childList: true,
            subtree: true,
        });
        setTimeout(()=>observer.disconnect(), 1000);
    }
    reset(){
        this.observer&&this.observer.disconnect();
        this.timeout&&clearTimeout(this.timeout);
        this.observer = this.timeout = null;
    }
    render(){ return this.props.children; }
}
E.Nav_hook = withRouter(Nav_hook);

const STYLE_NONE = {position: 'fixed', top: '-1000px'};
const Clipboard = ()=><textarea className="copy_area" style={STYLE_NONE}/>;
Clipboard.copy = text=>{
    if (!text)
        return;
    if (_.get(navigator, 'clipboard.writeText'))
    {
        navigator.clipboard.writeText(text);
        return true;
    }
    const textarea = document.querySelector('textarea.copy_area');
    if (!textarea)
        return;
    textarea.value = text;
    textarea.select();
    try {
        document.execCommand('copy');
        return true;
    } catch(e){ return void console.log('Oops, unable to copy'); }
};
E.Clipboard = Clipboard;

const Copy_tooltip = props=>{
    const {copied_msg = 'Copied!', click_msg = 'Copy to clipboard',
        swallow_click, disabled, on_fail, on_copy, children, pointer} = props;
    const [copied, set_copied] = use_state(false);
    const clr_copy = ()=>set_copied(false);
    const copy = e=>{
        if (swallow_click)
            e.stopPropagation();
        if (disabled)
            return;
        let text = props.text;
        if (typeof text == 'function')
            text = text();
        if (!text || !Clipboard.copy(text))
            return on_fail&&on_fail();
        set_copied(true);
        if (on_copy)
            on_copy();
    };
    return <Tooltip tooltip={copied ? copied_msg : click_msg}>
      <span className={classnames('copy_hover_area', {pointer})}
        onClick={copy} onMouseOut={clr_copy}>
        {children}
      </span>
    </Tooltip>;
};
E.Copy_tooltip = Copy_tooltip;

const Raw_text = props=>(props.children||'').split('\n').map((line, i)=>{
    line = line.replace(/^ */, v=>v.replace(/ /g, '\u00A0'));
    return line ? <div key={i}>{line}</div> : <br key={i}/>;
});
E.Raw_text = Raw_text;

const Linkify = props=>{
    if (!props.children)
        return null;
    let link_rx = /(https?:[^\s<>]*[^.\s<>])/gi;
    let mk_part = (p, i)=>link_rx.test(p) ?
        <a key={i} href={p}>{zescape.uri(p)}</a> :
        <span key={i}>{p}</span>;
    let mk_parts = t=>t.split(link_rx).map(mk_part);
    let mk_line = (line, i)=>line ?
        <div key={i}>{mk_parts(line)}</div> :
        <br key={i}/>;
    let mk_lines = t=>t.split('\n').map(mk_line);
    let root_fn = props.multiline ? mk_lines : mk_parts;
    return <React.Fragment>{root_fn(props.children)}</React.Fragment>;
};
E.Linkify = Linkify;

class Try_render extends Pure_component {
    state = {has_error: false};
    componentDidCatch(error){
        console.error('Failed to render error component', error);
        this.setState({has_error: true, error});
    }
    render(){
        let {has_error} = this.state;
        let {children, fallback} = this.props;
        return has_error ? fallback : children;
    }
}

class Cp_error_boundary extends Pure_component {
    id = www_util.uuid();
    state = {has_error: false};
    componentDidCatch(error, info){
        if (error.message.includes('to be defined'))
        {
            error.arrival = setdb.get('login.arrival');
            error.message = `${error.message} (arrival: ${error.arrival})`;
        }
        this.setState({has_error: true, error: error.stack, error_info: info});
        if (!setdb.get('login.user.is_root'))
        {
            hotjar_util.record_error('cp_error',
                {prepare: true, timeout: 30*date.ms.MIN});
            hotjar_util.hj_trigger(this.id);
        }
        info.err_id = this.id;
        if (this.props.log)
            this.props.log(error, info);
    }
    componentDidMount(){
        hotjar_util.record_error('cp_error',
            {tags: ['cp_error', 'react_error']});
    }
    render(){
        let {has_error, error, error_info} = this.state;
        let {children, error_component: Component, error_ui} = this.props;
        if (has_error)
        {
            if (Component)
            {
                return <Try_render fallback={error_ui||null}>
                  <Component error={error} info={error_info}/>
                </Try_render>;
            }
            return error_ui||null;
        }
        return children;
    }
}
E.Cp_error_boundary = Cp_error_boundary;

// XXX kirilla: HOC names should be lowercase to distinct them from components
E.With_ref = Component=>React.forwardRef(function with_ref(props, ref){
    return <Component {...props} forwardedRef={ref}/>;
});

E.with_setdb = (Comp, setdb_mapping)=>{
    const With_setdb = React.forwardRef((props, ref)=>{
        let [setdb_props, set_setdb_props] = use_classic_state({});
        use_effect(()=>{
            let handlers = _.toPairs(setdb_mapping).map(([p, key])=>
                setdb.on(key, v=>set_setdb_props({[p]: v})));
            return ()=>handlers.forEach(setdb.off);
        }, []);
        return <Comp ref={ref} {...setdb_props} {...props}/>;
    });
    With_setdb.displayName = `with_setdb(${Comp.displayName||Comp.name})`;
    return With_setdb;
};

Object.assign(E, react_hooks);

return E; }); // eslint-disable-line
